<template>
    <div>
        <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;"
                   icon='el-icon-plus' size='mini' type="primary" @click="dataFormSubmit('dataform')">保存
        </el-button>
        <el-form :model="dataform" :rules="dataRule" ref="dataform" size="small" label-width="150px" style="margin-top:5px">
            <h3>企业资源情况</h3>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="总人数" prop="totalNum">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.totalNum"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="技术人员" prop="technician">
                        <el-input  :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.technician"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="品质管理人员" prop="qualityControl">
                        <el-input  :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.qualityControl"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="操作人员" prop="operator">
                        <el-input  :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.operator"></el-input>
                    </el-form-item>
                </el-col>
                <!--<el-col :span="11">-->
                <!--<el-form-item label="试制技术人员" prop="trialproduce">-->
                <!--<el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.trialproduce"></el-input>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
            </el-row>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="占地面积(m²)" prop="areaCovered">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.areaCovered"/>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="生产面积(m²)" prop="productionArea">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.productionArea"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="建筑面积(m²)" prop="buildingArea">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.buildingArea"/>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="辅助面积(m²)" prop="auxiliaryArea">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.auxiliaryArea"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="固定资产原值(万元)" prop="faOriginalValue">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.faOriginalValue"/>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="固定资产净值(万元)" prop="faNetValue">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.faNetValue"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="80">
                <el-col :span="11">
                    <el-form-item label="流动资产原值(万元)" prop="laOriginalValue">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.laOriginalValue"/>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="自有流动资金(万元)" prop="fluidFund">
                        <el-input type="number" :disabled="this.applyStatus == '1' || this.applyStatus == '3'" v-model="dataform.fluidFund"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import {getBasicInfo,updateBasicInfoById} from '@/controller/portal'
    import {getSupplieInfo1} from '@/controller/supplier'

    export default {
        data() {
            return {
                handleSaveLoading:false,
                dataList: [],
                // uuid: '',
                dataform: {
                    basicInfoId: '',
                    technician: '',
                    operator: '',
                    qualityControl: '',
                    trialproduce: '',
                    totalNum: '',
                    areaCovered: '',
                    productionArea: '',
                    buildingArea: '',
                    auxiliaryArea: '',
                    faOriginalValue: '',
                    faNetValue: '',
                    laOriginalValue: '',
                    fluidFund: ''
                },
                //必填项目：总人数，技术人员，品质管理人员，操作人员，占地面积，生产面积，建筑面积 
                dataRule: {
                    totalNum: [{required: true, message: '不能为空', trigger: 'blur'}],
                    technician: [{required: true, message: '不能为空', trigger: 'blur'}],
                    qualityControl: [{required: true, message: '不能为空', trigger: 'blur'}],
                    operator: [{required: true, message: '不能为空', trigger: 'blur'}],
                    areaCovered: [{required: true, message: '不能为空', trigger: 'blur'}],
                    productionArea: [{required: true, message: '不能为空', trigger: 'blur'}],
                    buildingArea: [{required: true, message: '不能为空', trigger: 'blur'}]
                },
                applyStatus: '',
                basicInfoId: ''
            }
        },

        props: {
            superId: Number
        },

        methods: {
            //查询数据根据主键
            getDataList() {
                getSupplieInfo1({
                    'id': this.superId
                }).then(data => {
                    if (data.code === '00') {
                        this.dataform.basicInfoId = data.body.id
                        this.dataform.technician = data.body.technician
                        this.dataform.operator = data.body.operator
                        this.dataform.qualityControl = data.body.qualityControl
                        this.dataform.totalNum = data.body.totalNum
                        this.dataform.areaCovered = data.body.areaCovered
                        this.dataform.productionArea = data.body.productionArea
                        this.dataform.buildingArea = data.body.buildingArea
                        this.dataform.auxiliaryArea = data.body.auxiliaryArea
                        this.dataform.faOriginalValue = data.body.faOriginalValue
                        this.dataform.faNetValue = data.body.faNetValue
                        this.dataform.laOriginalValue = data.body.laOriginalValue
                        this.dataform.fluidFund = data.body.fluidFund
                    }
                    // console.log(this.dataform)
                    this.dataListLoading = false
                })
            },
            dataFormSubmit(formName) {
                if (!this.dataform.basicInfoId) {
                    this.$message.error("请先保存企业概况，其它信息后续进行操作。")
                    return;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.handleSaveLoading = true
                        updateBasicInfoById({
                                'id': this.dataform.basicInfoId,
                                'technician': this.dataform.technician,
                                'operator': this.dataform.operator,
                                'qualityControl': this.dataform.qualityControl,
                                'trialproduce': this.dataform.trialproduce,
                                'totalNum': this.dataform.totalNum,
                                'areaCovered': this.dataform.areaCovered,
                                'productionArea': this.dataform.productionArea,
                                'buildingArea': this.dataform.buildingArea,
                                'auxiliaryArea': this.dataform.auxiliaryArea,
                                'faOriginalValue': this.dataform.faOriginalValue,
                                'faNetValue': this.dataform.faNetValue,
                                'laOriginalValue': this.dataform.laOriginalValue,
                                'fluidFund': this.dataform.fluidFund,
                        }).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                })
                                this.getDataList()
                                this.handleSaveLoading = false
                            } else {
                                this.handleSaveLoading = false
                                this.$message.error(data.msg)
                            }
                        }).catch((e) => {
                            this.handleSaveLoading = false
                        })
                    }
                })
            }
        }
    }
</script>
